import { Component, ContentChild, Input, OnInit, TemplateRef } from '@angular/core';
import { CarouselModule } from 'primeng/carousel';
import { ButtonModule } from 'primeng/button';
import { TagModule } from 'primeng/tag';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-shared-carousel',
  standalone: true,
  imports: [CarouselModule, ButtonModule, TagModule ,CommonModule],
  templateUrl: './shared-carousel.component.html',
  styleUrls: ['./shared-carousel.component.scss']
})
export class SharedCarouselComponent implements OnInit {
  @Input() items: any[] = [];
  @Input() numVisible: number = 4;
  @Input() numScroll: number = 1;

  @Input() bodyTemplate!: TemplateRef<any>;
  responsiveOptions!: any[];

  ngOnInit() {
    this.responsiveOptions = [
      {
        breakpoint: '1400px',
        numVisible: this.numVisible,
        numScroll: this.numScroll
      },
      {
        breakpoint: '1220px',
        numVisible: this.numVisible,
        numScroll: this.numScroll
      },
      {
        breakpoint: '1100px',
        numVisible: Math.max(2, Math.floor(this.numVisible / 2)),
        numScroll: Math.max(2, Math.floor(this.numScroll / 2))
      },
      {
        breakpoint: '700px',
        numVisible: 1,
        numScroll: 1
      }
    ];
  }

  get hasEnoughItems(): boolean {
    return (this.items?.length || 0) >= 2;
  }
}
